import { useEffect } from 'react';

import { useFetchUbicacionProductosEnabled } from '@/shared/actions/erp';
import { AlertSeverityEnum, OrdenTrabajo } from '@/shared/interfaces';
import {
  CategoryProducCodeEnum,
  IUbicacionProducto,
} from '@/shared/interfaces/erp/inventario';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';

type UseEquiposDisponiblesProps = {
  ordenTrabajo: OrdenTrabajo;
};
export const useEquiposFlotaActivacionInstall = ({
  ordenTrabajo,
}: UseEquiposDisponiblesProps) => {
  ///* global state ==========================
  const setAlert = useUiStore(s => s.setAlert);
  const setItemsInStorage = useMaterialesUtilizadosStore(
    s => s.setSelectedItems
  );

  ///* fetch data ==========================
  const {
    data: itemsDisponiblesPaging,
    isLoading: isLoadingItemsDisponibles,
    isRefetching: isRefetchingItemsDisponibles,
  } = useFetchUbicacionProductosEnabled({
    enabled: !!ordenTrabajo?.id_orden_trabajo,
    params: {
      ubicacion: ordenTrabajo?.flota_data?.ubicacion,
      page_size: 900,
    },
  });

  ///* effects ==========================
  // set up equipos disponibles from Ubicacion and validate ONT stock
  useEffect(() => {
    if (
      !ordenTrabajo?.id_orden_trabajo ||
      isLoadingItemsDisponibles ||
      isRefetchingItemsDisponibles
    )
      return;

    ///* validate stock in ubicacion/flota
    const items = itemsDisponiblesPaging?.data?.data || [];
    if (!items.length) {
      setAlert(
        true,
        'No cuenta con items en la flota',
        AlertSeverityEnum.warning
      );
    }

    ///* EQUIPOS disponibles -------------------
    const ONTEquipo = items.find(
      (item: IUbicacionProducto) =>
        item.producto_data?.categoria_producto ===
          CategoryProducCodeEnum.EQUIPOS && item.producto_data?.es_ont
    );

    // if (!ONTEquipo) {
    //   setAlert(
    //     true,
    //     'No cuenta con quipos ONT en la flota',
    //     AlertSeverityEnum.warning
    //   );
    // }

    setItemsInStorage(
      [
        {
          ...ONTEquipo,
          cantidadUtilizada: 1,
          cantidad: 1,
          series: ONTEquipo?.series || [],
          contieneSeries: !!ONTEquipo?.series?.length,
          selectedSeries: [],
        },
      ],
      MaterialesKey.equipoSerieUtilizadaActivacion
    );
  }, [
    ordenTrabajo,
    itemsDisponiblesPaging,
    isLoadingItemsDisponibles,
    isRefetchingItemsDisponibles,
  ]);
};
